export const createFullDatetime = (date, time) => {
  const [year, month, day] = date.split("-").map(Number);
  const [hours, minutes] = time.split(":").map(Number);
  const datetime = new Date(
    Date.UTC(year, month - 1, day, hours, minutes, 0, 0)
  );
  return datetime.toISOString();
};

export const formatDatetime = (isoString) => {
  if (!isoString) return "-";
  try {
    const date = new Date(isoString);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  } catch (error) {
    return isoString;
  }
};

export const createFullDatetimeWithTimezone = (date, time) => {
  const [year, month, day] = date.split("-").map(Number);
  const [hours, minutes] = time.split(":").map(Number);

  const egyptDate = new Date(year, month - 1, day, hours, minutes, 0, 0);

  return egyptDate.toISOString();
};

export const isDateOlderThanSevenDays = (dateStr) => {
  const recordDate = new Date(dateStr);
  const today = new Date();
  const diffTime = Math.abs(today - recordDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays > 7;
};

export const isSameDayAsToday = (dateStr) => {
  const recordDate = new Date(dateStr);
  const today = new Date();
  recordDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);
  return recordDate.getTime() === today.getTime();
};